import UserModel from '@/modules/user/components/list/models/user-model'

// actions
const ACTION_PREFIX = 'user/edit'
const RESET_STATE = `${ACTION_PREFIX}/resetState`
const UPDATE_USER_DATA = `${ACTION_PREFIX}/updateUserData`

// reducer
const initialState = {
  user: new UserModel(),
  editUserModalOpen: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_USER_DATA:
      const { user: userData } = action
      const newUser = new UserModel({ ...state.user, ...userData })
      return { ...state, user: newUser }

    case RESET_STATE:
      return initialState

    default:
      return state
  }
};

// action creators
export const updateUserData = (data) => ({
  type: UPDATE_USER_DATA,
  user: data,
})

export const resetState = () => ({
  type: RESET_STATE,
})
